import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

const QUICK = ["👍", "✅", "❤️", "👀"];

const react = async (m, emoji, onChanged) => {
  try { await api.post(`/messages/${m.id}/reactions`, { emoji }); await onChanged(); }
  catch (err) { toast.error(formatApiError(err)); }
};

export function QuickReactions({ m, mine, onChanged }) {
  return (
    <div className={`flex items-center gap-0.5 rounded-full border border-slate-200 bg-white shadow-sm px-1 py-0.5 md:opacity-0 md:group-hover:opacity-100 transition-opacity ${mine ? "mr-1" : "ml-1"}`} data-testid={`reaction-quick-${m.id}`}>
      {QUICK.map((e) => <button key={e} type="button" onClick={() => react(m, e, onChanged)} className="h-6 w-6 rounded-full hover:bg-slate-100 text-sm leading-none" title={`React ${e}`} data-testid={`react-${e}-${m.id}`}>{e}</button>)}
    </div>
  );
}

export function ReactionChips({ m, mine, userId, onChanged }) {
  const groups = (m.reactions || []).reduce((acc, r) => { (acc[r.emoji] = acc[r.emoji] || []).push(r); return acc; }, {});
  if (!Object.keys(groups).length) return null;
  return (
    <div className={`flex flex-wrap gap-1 mt-1 ${mine ? "justify-end" : ""}`} data-testid={`reactions-${m.id}`}>
      {Object.entries(groups).map(([e, rs]) => {
        const me = rs.some((r) => r.user_id === userId);
        return <button key={e} type="button" onClick={() => react(m, e, onChanged)} title={rs.map((r) => r.name).join(", ")} className={`inline-flex items-center gap-1 rounded-full border px-1.5 py-0.5 text-xs ${me ? "bg-blue-50 border-blue-300 text-blue-800" : "bg-white border-slate-200 text-slate-700"}`} data-testid={`reaction-chip-${e}-${m.id}`}>{e}{rs.length > 1 && <span className="font-mono">{rs.length}</span>}</button>;
      })}
    </div>
  );
}
